module.exports = __webpack_public_path__ + "img/pw_cannabis.eba392f1.png";